import React from 'react'
import style from './PrimeraParte.module.css'

const PrimeraParte = ({ t }) => {
  return (
    <div className={style.container}>
      <p className={style.titulo}>{t('Products.InteractiveVoiceResponse.FirstPart.title')}</p>
      <div className={style.divContainer}>
        <div className={style.divIzq}>
          <p className={style.text}>{t('Products.InteractiveVoiceResponse.FirstPart.text')}</p>
          <p className={style.text}>{t('Products.InteractiveVoiceResponse.FirstPart.text2')}</p>
          <p className={style.text}><strong>{t('Products.InteractiveVoiceResponse.FirstPart.text3')}</strong> {t('Products.InteractiveVoiceResponse.FirstPart.text4')}</p>
        </div>
        <div className={style.divDer}>
          <p className={style.title}>{t('Products.InteractiveVoiceResponse.FirstPart.title4')}</p>
          <div className={style.separador}></div>
          <ul className={style.ul}>
            <li className={style.li}>{t('Products.InteractiveVoiceResponse.FirstPart.li')}</li>
            <li className={style.li}>{t('Products.InteractiveVoiceResponse.FirstPart.li2')}</li>
            <li className={style.li}>{t('Products.InteractiveVoiceResponse.FirstPart.li3')}</li>
            <li className={style.li}>{t('Products.InteractiveVoiceResponse.FirstPart.li4')}</li>
            <li className={style.li}>{t('Products.InteractiveVoiceResponse.FirstPart.li5')}</li>
            <li className={style.li}>{t('Products.InteractiveVoiceResponse.FirstPart.li6')}</li>
            <li className={style.li}>{t('Products.InteractiveVoiceResponse.FirstPart.li7')}</li>
            <li className={style.li}>{t('Products.InteractiveVoiceResponse.FirstPart.li8')}</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default PrimeraParte